export const adBpCondition = type => {
    let ww = window.innerWidth

    let ad_bp_conditions = {
        all: true,
        mobile: ww < 768,
        tablet: ww >= 768 && ww < 1200,
        desktop: ww >= 1200,
        small: ww < 992,
    }

    return ad_bp_conditions[type]
}
